import {assign, concat, flow, get, reduce} from '@yandex-delivery/utils'
import {useMemo} from 'react'
import type {Poll, PollUserAnswerChoice, Subpoll} from 'src/api'

import type {FormType, PollType} from './Form.types'

const getUserChoices: (poll: Poll) => PollType = flow(
  get('subpolls'),
  reduce(
    (acc: PollUserAnswerChoice[], {user_choices}: Subpoll) => (user_choices ? concat(acc, user_choices) : acc),
    [],
  ),
  reduce(
    (choicesAcc: PollType, choice: PollUserAnswerChoice) =>
      assign(choicesAcc, {[choice.question_id]: choice.answers_ids}),
    {},
  ),
)

export const useDefaultValues = (poll: Poll): FormType => {
  const defaultValues = useMemo<FormType>(() => ({poll: getUserChoices(poll)}), [poll])

  return defaultValues
}
